import React from "react"
import * as styles from "./footnotes.module.scss"
import Text from './text'

export default function Footnotes(props) {
    return <Text className={styles.footnotes} content={props.text}/>
}